export const NOTE_LIST_REQUEST = "NOTE_LIST_REQUEST";
export const NOTE_LIST_SUCCESS = "NOTE_LIST_SUCCESS";
export const NOTE_LIST_FAIL =    "NOTE_LIST_FAIL";

export const NOTES_CREATE_REQUEST = "NOTES_CREATE_REQUEST";
export const NOTES_CREATE_SUCCESS = "NOTES_CREATE_SUCCESS";
export const NOTES_CREATE_FAIL =    "NOTES_CREATE_FAIL";

export const NOTES_UPDATE_REQUEST = "NOTES_UPDATE_REQUEST";
export const NOTES_UPDATE_SUCCESS = "NOTES_UPDATE_SUCCESS";
export const NOTES_UPDATE_FAIL =    "NOTES_UPDATE_FAIL";

export const NOTES_DELETE_REQUEST = "NOTES_DELETE_REQUEST";
export const NOTES_DELETE_SUCCESS = "NOTES_DELETE_SUCCESS";
export const NOTES_DELETE_FAIL =    "NOTES_DELETE_FAIL";